// extracted by mini-css-extract-plugin
export var contentBody = "_8n-9";
export var headerImage = "_8n-2";
export var imageButton = "_8n-7";
export var imageButtonIcon = "_8n-8";
export var imageHeader = "_8n-4";
export var imageHeaderText = "_8n-5";
export var imageOverlay = "_8n-3";
export var imageTitle = "_8n-6";
export var imageWrapper = "_8n-1";
export var taskList = "_8n-a";
export var widget = "_8n-0";